module.exports = __webpack_public_path__ + "img/whatsapp.1af68193.svg";